export const getCityList = (state) => state.retailer.cityList;
export const getRetailerInfo = (state) => state.retailer.retailer;
export const getProfileData = (state) => state.retailer.retailer;
export const getLastRetailerImport = (state) => state.retailer.lastRetailerImport;
export const getRetailerToastId = (state) => state.retailer.toastId;
export const getPatchedRetailerData = (state) => state.retailer.patchedRetailerData;
